// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.look-disabled {
  color: var(--bs-btn-disabled-color);
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn {
  border-radius: 10px;
}

.btn-with-icon i {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/components/manage-respondents-v2/manage-respondents-v2.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/dashboard/components/manage-respondents-v2/manage-respondents-v2.component.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;ACCF;;ADEA;EACE,mBAAA;ACCF;;ADEA;EACE,SAAA;ACCF","sourcesContent":[".look-disabled {\r\n  color: var(--bs-btn-disabled-color);\r\n  background-color: var(--bs-btn-disabled-bg);\r\n  border-color: var(--bs-btn-disabled-border-color);\r\n  opacity: var(--bs-btn-disabled-opacity);\r\n}\r\n\r\n.btn {\r\n  border-radius: 10px;\r\n}\r\n\r\n.btn-with-icon i {\r\n  margin: 0;\r\n}\r\n",".look-disabled {\n  color: var(--bs-btn-disabled-color);\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn {\n  border-radius: 10px;\n}\n\n.btn-with-icon i {\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
